import React from 'react';
import MenuMain from '../../MenuMain';
import { FormPerfis } from '../../components/FormPerfis';
import { AppFooter } from '../../AppFooter';
import { OPCOES_DEFICIENCIA } from '../../utils/constantes';

export default function CadastrarPerfisPage() {

  const defaultValues = {
    'nome': '',
    'cpf': '',
    'email': '',
    'dataNascimento': '',
    'responsavel': '',
    'celular': '',
    'telefone': '',
    'testeCanto': '',
    'lgpdAceite': false,
    'tipo': 'INSCRITO', // Sugestão: iniciar com um tipo padrão
    'tipoPerfis': ['INSCRITO', 'ALUNO', 'INSTRUTOR', 'ADMIN'],
    'deficiencia': 'NENHUM', // Alinhado com o Enum
    'deficienciaPerfis': OPCOES_DEFICIENCIA, // Agora passa a lista de objetos
    'obs': ''
  }

  return (
    <div>
      <MenuMain>
         <FormPerfis
          defaultValues={defaultValues}
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}